module.exports = __webpack_public_path__ + "static/media/Filters.108a9046.PNG";